import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import './Advantages.css';
import {useTranslation} from "react-i18next";

const Advantages = () => {
    const {t} = useTranslation();
    const infoData = [
        {
            title: t("pages.home.advantages.1.title"),
            description: t("pages.home.advantages.1.description"),
            icon: t("pages.home.advantages.1.icon")
        },
        {
            title: t("pages.home.advantages.2.title"),
            description: t("pages.home.advantages.2.description"),
            icon: t("pages.home.advantages.2.icon")
        },
        {
            title: t("pages.home.advantages.3.title"),
            description: t("pages.home.advantages.3.description"),
            icon: t("pages.home.advantages.3.icon")
        },
        {
            title: t("pages.home.advantages.4.title"),
            description: t("pages.home.advantages.4.description"),
            icon: t("pages.home.advantages.4.icon")
        },

    ];

    return (
        <Container
            fluid
            className="py-5 bg-white"
        >
            <Row className="g-4">
                {infoData.map((item, index) => (
                    <Col md={3} sm={6} key={index}>
                        <div className={"text-center bg-white p-5 border-1"}>
                            <div className={"mb-3 font-size-40px"}
                            >
                                {item.icon}
                            </div>
                            <h5 className={"fw-bold"}>{item.title}</h5>
                            <p className={"mt-1 color-6c757d"}>{item.description}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Advantages;
